const CurrencyDisplay = ({
  language,
  currency,
  value,
}: {
  language?: string;
  currency: string; //'USD' | 'EUR' | 'GBP' | 'HKD'
  value: number;
}) => {
  language = language || 'en-UK';
  if (currency === 'USD') {
    return Intl.NumberFormat(language, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      currencyDisplay: 'narrowSymbol',
    }).format(value);
  }
  if (currency === 'EUR') {
    return (
      Intl.NumberFormat(language, {
        style: 'decimal',
        currency: currency,
        minimumFractionDigits: 0,
      }).format(value) + '€'
    );
  }
  return Intl.NumberFormat(language, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
  }).format(value);
};

export default CurrencyDisplay;
